<template>
  <g transform="matrix(1,0,0,1,0,0)">
    <path
      d="M 22.19,1.81c-1.424-1.418-3.727-1.413-5.145,0.011c-0.008,0.008-0.016,0.016-0.024,0.024l-14.5,14.5 L0.75,23.25l6.905-1.771l14.5-14.5c1.437-1.404,1.463-3.708,0.059-5.145C22.206,1.826,22.198,1.818,22.19,1.81z "
      stroke="currentColor"
      fill="none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path 
      d="M 16.606,2.26 l5.134,5.134 "
      stroke="currentColor"
      fill="none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 14.512,4.354l5.134,5.134 "
      stroke="currentColor"
      fill="none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 2.521,16.345l5.139,5.129"
      stroke="currentColor"
      fill="none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;
  
export default {
  name: "IconEdit",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {
  },
  computed: {
  }
};
</script>